export const SORT_MAP = {
  '/home': 'Active',
  '/top': 'TopDay',
  '/best': 'Hot',
  '/hot': 'New',
};
